module.exports = __webpack_public_path__ + "static/media/wepik-export-20230524040723Ijko.3fac5acd.png";